import React from 'react';
import numeral from 'numeral';
import moment from 'moment';
import _ from 'lodash';
import DyzioInstagramEmbed from '../../components/dyzio-instagram-embed';
import { Table, Label, Grid, Card } from 'semantic-ui-react';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import TextHighlighter from 'dyzio-shared-components/lib/components/text-highlighter';

const cf = num => numeral(num).format('0,0');

const tableStyle = { padding: 5 };

const InstagramInsightsModal = ({ latestStatistic, popupToggleHandler, open, post, hashtags }) => {
  if (!latestStatistic) return null;
  const { insights } = latestStatistic;
  if (!open) return null;

  const collectedDate = moment(latestStatistic.createdDate).format('MMMM Do YYYY, h:mm:ss a');
  const publishedDate = moment(post.publishedDate).format('MMMM Do YYYY, h:mm:ss a');

  console.log(hashtags);
  const highlighedHashtags = hashtags ? _.split(hashtags, ',') : [];

  return (
    <DyzioModal
      headerText="Instagram Post Insights"
      onClose={popupToggleHandler}
    >
      <Grid>
        <Grid.Row columns="two">
          <Grid.Column>
            <DyzioInstagramEmbed
              assetId={latestStatistic.instagramId}
            />
          </Grid.Column>
          <Grid.Column>
            <Card fluid color="pink">
              <Card.Content>
                <Card.Header>Instagram Insights</Card.Header>
              </Card.Content>
              <Card.Content>
                <Table basic="very" celled fluid small style={tableStyle}>
                  <Table.Body>

                    <Table.Row>
                      <Table.Cell>
                        <b>Reach</b>
                      </Table.Cell>
                      <Table.Cell>
                        { cf(insights.reach) }
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <b>Impressions</b>
                      </Table.Cell>
                      <Table.Cell>
                        { cf(insights.impressions) }
                      </Table.Cell>
                    </Table.Row>


                    <Table.Row>
                      <Table.Cell>
                        <b>Engagement</b>
                      </Table.Cell>
                      <Table.Cell>
                        { cf(insights.engagement) }
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <b>Saved</b>
                      </Table.Cell>
                      <Table.Cell>
                        { cf(insights.saved) }
                      </Table.Cell>
                    </Table.Row>

                  </Table.Body>
                </Table>
                <p className="centered">
                  <Label centered icon="clock" color="grey" basic content={`post published ${publishedDate}`} />
                </p>
                <div style={{ height: 5 }}>&nbsp;</div>
                <p className="centered">
                  <Label centered icon="clock" color="grey" basic content={`data collected ${collectedDate}`} />
                </p>
              </Card.Content>
            </Card>

            <Card fluid color="blue">
              <Card.Content>
                <Card.Header>Caption</Card.Header>
                <Card.Meta>highlighted text shows hashtag matches</Card.Meta>
              </Card.Content>
              <Card.Content>
                <TextHighlighter text={post.text} words={highlighedHashtags} />
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </DyzioModal>
  );
};


export default InstagramInsightsModal;



/** WEBPACK FOOTER **
 ** ./src/components/instagram-insights-modal/index.js
 **/